import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as bootstrap from "bootstrap";

export default function Carousel({ items, isGoto = false }) {
  const carouselRef = useRef(null);
  const navigate = useNavigate();
  const [carousel, setCarousel] = useState(null);
  useEffect(() => {
    setCarousel(
      new bootstrap.Carousel(carouselRef.current, {
        ride: false,
        wrap: false,
        pause: true,
        touch: true,
      }),
    );

    return () => {
      carousel && carousel?.dispose();
    };
  }, [navigate]);

  const handleNext = () => {
    carousel?.next();
  };
  return (
    <div
      ref={carouselRef}
      id="carouselExampleIndicators"
      className="carousel slide"
      //   data-bs-ride="carousel"
    >
      <div className="carousel-indicators">
        {items.map((item, index) => {
          return (
            <button
              key={index}
              type="button"
              disabled={!isGoto}
              data-bs-target="#carouselExampleIndicators"
              data-bs-slide-to={index}
              className={`${index === 0 ? "active" : ""}`}
              aria-current="true"
              aria-label={`Slide ${item.key}`}
            ></button>
          );
        })}
      </div>
      <div className="carousel-inner">
        {items.map((item, index) => {
          const Comp = item.item;
          return <Comp handleNext={handleNext} />;
        })}
      </div>
    </div>
  );
}
